module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bouteille-single"
  }, [_c('app-header', {
    attrs: {
      "icon": "bottle"
    }
  }, [_vm._v("\n        Bouteille\n    ")]), _vm._v(" "), _c('action-bar', {
    attrs: {
      "back": {
        name: 'liste-bouteilles'
      }
    }
  }, [(!this.isRestit && this.bouteille.actif === true) ? _c('a', {
    staticClass: "btn add btn-full main-action cloturer",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.modifBouteilleStatus
    }
  }, [_c('i', {
    staticClass: "icon-go"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Clôturer")]), _c('br'), _vm._v(" la bouteille\n            ")])]) : _vm._e(), _vm._v(" "), (!this.isRestit && this.bouteille.actif === false) ? _c('a', {
    staticClass: "btn add btn-full main-action rendre",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.modifBouteilleStatus
    }
  }, [_c('i', {
    staticClass: "icon-go"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Rendre")]), _c('br'), _vm._v(" la bouteille\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bouteille"
    }
  }, [(this.isRestit) ? _c('p', [_vm._v("Bouteille restituée.")]) : _vm._e(), _vm._v(" "), (_vm.bouteille.type) ? _c('div', {
    staticClass: "topbouteille wrap",
    class: _vm.shortTypeName
  }, [(this.bouteille.favori !== null && this.bouteille.favori != undefined && this.bouteille.favori.id === _vm.$user.id) ? _c('p', [_c('i', {
    staticClass: "icon-star",
    staticStyle: {
      "color": "#f9d342"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "typebouteille"
    }
  }, [_vm._v(_vm._s(_vm.shortTypeName))]), _vm._v(" "), _c('p', [_vm._v("\n                Bouteille\n                "), (_vm.bouteille.nom) ? _c('span', {
    attrs: {
      "id": "nombouteille"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.nom.nom))]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "id": "poidsmax",
      "data-max": "10"
    }
  }, [_vm._v("(" + _vm._s(_vm.bouteille.poids_max) + "Kg)")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bouteille.fournisseur) ? _c('span', {
    attrs: {
      "id": "distributeur"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.fournisseur.nom))]) : _vm._e(), _vm._v(" "), (_vm.bouteille.marque) ? _c('span', {
    attrs: {
      "id": "marque"
    }
  }, [(_vm.bouteille.fournisseur) ? [_vm._v("· ")] : _vm._e(), _vm._v(_vm._s(_vm.bouteille.marque))], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mainbouteille wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.bouteille.type) ? _c('div', {
    staticClass: "btn btn-full codebouteille",
    class: _vm.shortTypeName
  }, [_c('i', {
    staticClass: "icon-gas"
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "codebouteille"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.code))])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.fluide) ? _c('div', {
    staticClass: "btn btn-full fluide",
    class: _vm.bouteille.fluide.regenerated ? 'regen' : ''
  }, [_c('i', {
    staticClass: "icon-fluid"
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "nomfluide"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.fluide.nom))])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.otag) ? _c('div', {
    staticClass: "btn btn-full otag"
  }, [_c('i', {
    staticClass: "icon-otag"
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "otag"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.otag))])]) : _vm._e(), _vm._v(" "), (!this.isRestit && this.bouteille.actif === true && this.bouteille.otag === null) ? _c('a', {
    staticClass: "btn btn-full otag",
    attrs: {
      "href": ("fi360://scan?success=tryGoTo&bouteille=" + (_vm.bouteille.id))
    }
  }, [_c('i', {
    staticClass: "icon-otag"
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Ajouter une otag")])])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.actif === false) ? _c('div', {
    staticClass: "block-cloture"
  }, [_c('strong', [_vm._v("BOUTEILLE CLOTURÉE")])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.tare) ? _c('div', [_c('p', [_vm._v("Tare : "), _c('strong', [_vm._v(_vm._s((_vm.bouteille.tare).toFixed(2)) + " Kg")])]), _vm._v(" "), _c('p', [_vm._v("Tare + net : "), _c('strong', [_vm._v(" " + _vm._s(_vm.getPoidsBrut(_vm.bouteille.tare, _vm.bouteille.poids_net)) + " Kg")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calendar"
  }, [_c('i', {
    staticClass: "icon-calend"
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Retour prévu\n                        "), _c('br'), _vm._v(" "), _c('strong', [_c('span', {
    attrs: {
      "id": "dateretour"
    }
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.bouteille.date_retour_prevue)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.bouteille.ref_livraison !== null) ? _c('div', {
    staticClass: "calendar"
  }, [_c('i', {
    staticClass: "icon-marquage"
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Référence livraison\n                        "), _c('br'), _vm._v(" "), _c('strong', [_c('span', {
    attrs: {
      "id": "reference"
    }
  }, [_vm._v(_vm._s(_vm.refLivraisonTruncate))])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e(), _vm._v(" "), (_vm.bouteille.otag !== null) ? _c('a', {
    staticClass: "btn localisation",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleMap($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-geoloc"
  }), _vm._v(" "), _c('strong', [_vm._v("LOCALISER")]), _vm._v("\n                    LA BOUTEILLE\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "id": "showMap"
    }
  }, [_c('div', {
    ref: "displayMap",
    attrs: {
      "id": "displayMap"
    }
  })]), _vm._v(" "), (_vm.historiques.length !== 0) ? _c('a', {
    staticClass: "btn localisation",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleHistoryUser()
      }
    }
  }, [_c('i', {
    staticClass: "icon-users"
  }), _vm._v(" "), _c('strong', [_vm._v("Historique")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "showHistoryUser"
    }
  }, _vm._l((_vm.historiques), function(histo) {
    return _c('div', {
      key: histo.id,
      staticClass: "histo"
    }, [_c('span', {
      staticClass: "user"
    }, [_vm._v("Par " + _vm._s(histo.user))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v("le " + _vm._s(_vm._f("dateFormat")(histo.date)))]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  }), 0), _vm._v(" "), (_vm.bouteille.type === 'Fluide frigorigène' && _vm.bouteille.actif === true) ? _c('a', {
    staticClass: "btn localisation",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToRegul($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-tools"
  }), _vm._v(" "), _c('span', [_vm._v("Régulariser")])]) : _vm._e(), _vm._v(" "), (!this.bouteille.favori || (this.bouteille.favori && this.bouteille.favori.id !== this.$user.id)) ? _c('div', {
    staticClass: "btn btn-full favori",
    on: {
      "click": _vm.addThisBottleToFavorite
    }
  }, [_c('i', {
    staticClass: "icon-star"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Ajouter aux favoris")])]) : _c('div', {
    staticClass: "btn btn-full favori",
    on: {
      "click": _vm.removeThisBottleToFavorite
    }
  }, [_c('i', {
    staticClass: "icon-star"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Retirer des favoris")])]), _vm._v(" "), (_vm.isMagasinier() && !_vm.isRestit) ? _c('div', {
    staticClass: "btn btn-full favori",
    on: {
      "click": _vm.affecterFavori
    }
  }, [_c('i', {
    staticClass: "icon-star"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                        Affecter le favori\n                        "), (_vm.bouteille.favori && _vm.bouteille.favori.id) ? [_c('br'), _c('small', [_vm._v(_vm._s(_vm.bouteille.favori.last_name) + " " + _vm._s(_vm.bouteille.favori.first_name))])] : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    attrs: {
      "id": "levelbouteille"
    }
  }, [_c('i', {
    staticClass: "icon-bottle"
  }), _vm._v(" "), _c('span', {
    style: (_vm.computedHeight),
    attrs: {
      "id": "fill"
    }
  }, [_c('i', {
    staticClass: "icon-bottle filling"
  })]), _vm._v(" "), _c('span', {
    style: (_vm.computedHeight),
    attrs: {
      "id": "indicators"
    }
  }, [_c('div', {
    staticClass: "triangle"
  }), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "levelfill",
      "data-fill": "6"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.poids_net))]), _vm._v(" kg\n                            ")])])])]), _vm._v(" "), (_vm.bouteille.poids_net > 0 && _vm.operations.length > 0 && _vm.infoManip(_vm.operations[0].id_type) === 'déchet' && (_vm.bouteille.type === 'Transfert' || _vm.bouteille.type === 'Récupération')) ? _c('div', [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Fluide pour traitement")])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.poids_net > 0 && _vm.operations.length > 0 && _vm.infoManip(_vm.operations[0].id_type) !== 'déchet' && (_vm.bouteille.type === 'Transfert' || _vm.bouteille.type === 'Récupération')) ? _c('div', [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Fluide recyclé pour réintroduction")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "operations wrap"
  }, [_c('a', {
    staticClass: "btn-op btn history",
    attrs: {
      "id": "toggle-history",
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleHistory($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-link"
  }), _vm._v("\n                HISTORIQUE"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("BOUTEILLE")])]), _vm._v(" "), (_vm.operations.length > 0) ? _c('div', _vm._l((_vm.operations), function(op) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showHistory),
        expression: "showHistory"
      }],
      key: op.id,
      staticClass: "histo",
      class: _vm.getOpClass(op.type)
    }, [_c('span', {
      staticClass: "quantite"
    }, [_vm._v(_vm._s(op.quantite) + "Kg "), _c('span', {
      staticClass: "manip-label"
    }, [_vm._v(_vm._s(_vm.infoManip(op.id_type))), (op.fluideNom) ? [_vm._v(" · " + _vm._s(op.fluideNom))] : _vm._e()], 2)]), _vm._v(" "), (op.user) ? _c('span', {
      staticClass: "user"
    }, [_vm._v(_vm._s(op.user))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(op.date)))]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  }), 0) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b88e3ae8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/Bouteille.vue
// module id = 785
// module chunks = 0